import React from "react";

import { useSelector } from "react-redux";
import { Router } from "react-router-dom";

import Theme from "./Theme";
import history from "../utils/history";
import { ToastProvider } from "react-toast-notifications";
import Auth from "../utils/auth/Auth";
import LayoutSFC from "./Layout/LayoutSFC";
import AuthGuard from "../utils/auth/AuthGuard";
import Loading from '../sharedComponent/Loading';

export default props => {
  let loader = useSelector(store => store.loader);
  
  return (
        <Theme>
          <ToastProvider>
            <Auth>
              <Router history={history}>
                <AuthGuard>
                  <LayoutSFC />
                </AuthGuard>
              </Router>
            </Auth>
            {loader && <Loading />}
          </ToastProvider>
        </Theme>
  );
};
